import * as Sentry from '@sentry/react';

export const logError = (error: Error, context?: any) => {
  Sentry.captureException(error);
};

export const setUserIdForErrors = (user: Sentry.User) => {
  Sentry.configureScope(scope => {
    scope.setUser(user);
  });
};



// WEBPACK FOOTER //
// ./src/utils/ErrorLogger.ts